<template>
	<div>
		<div class="myheader">
			<div class="headLeft">
				<div class="headLeft_inner">
					<img src="../../assets/img/login/login.png" style="width: 40px;height: 40px;border-radius: 50%;">
					<p>{{name}}</p>
				</div>
				<p style="color: #000000;">{{level}}</p>
			</div>
			<div class="headRight">
				<img src="../../assets/img/main/邮箱.png">
				<router-link to="/changepassword">
					<p>修改密码</p>
				</router-link>
				<p @click="logout">退出</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginout
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {

			}
		},
		computed: {
			name() {
				return localStorage.getItem('userName')
			},
			level() {
				const level = localStorage.getItem('userLevel')
				if (level === '1') {
					return '一级管理员'
				}
				return '二级管理员'
			}
		},
		methods: {
			async logout() {
				await loginout({
					data: {},
					success: (res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(()=>{
							localStorage.removeItem('token')
							this.$router.replace('/')
						},1000)
					}
				})

			}
		}
	}
</script>

<style>
	.myheader {
		display: flex;
		justify-content: space-between;
		height: 60px;
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0px -2px #f2f2f2 inset;
	}

	.myheader p {
		/* padding-right: 50px;
		font-size: 14px;
		color: #4facfe;
		cursor: pointer; */
	}

	.headLeft {
		display: flex;
		margin-left: 250px;
		align-items: center;
	}

	.headLeft p {
		margin-left: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	.headLeft_inner {
		display: flex;
		align-items: center;
	}

	.headLeft_inner p {
		margin-left: 15px;

	}

	.headRight {
		width: 300px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}

	.headRight p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1890FF;
		cursor: pointer;
	}

	.headRight img {
		width: 25px;
		height: 25px;
		cursor: pointer;
	}
</style>
